import Account from "../pages/account/Account";

const protectedRoutes = [
    {
        path: "/account",
        element: <Account />,
    },
    {
        path: "/account/profile",
        element: <Account />,
    },
    {
        path: "/account/orders",
        element: <Account />,
    },
    {
        path: "/account/favourites",
        element: <Account />,
    },
    {
        path: "/account/notifications",
        element: <Account />,
    },
    {
        path: "/account/returns",
        element: <Account />,
    },
]
export default protectedRoutes;